/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to estimate token usage for a document
 * @export
 * @interface EstimateDocumentRequest
 */
export interface EstimateDocumentRequest {
    /**
     * 
     * @type {number}
     * @memberof EstimateDocumentRequest
     */
    documentId: number;
}

/**
 * Check if a given object implements the EstimateDocumentRequest interface.
 */
export function instanceOfEstimateDocumentRequest(value: object): value is EstimateDocumentRequest {
    if (!('documentId' in value) || value['documentId'] === undefined) return false;
    return true;
}

export function EstimateDocumentRequestFromJSON(json: any): EstimateDocumentRequest {
    return EstimateDocumentRequestFromJSONTyped(json, false);
}

export function EstimateDocumentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EstimateDocumentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'documentId': json['documentId'],
    };
}

export function EstimateDocumentRequestToJSON(json: any): EstimateDocumentRequest {
    return EstimateDocumentRequestToJSONTyped(json, false);
}

export function EstimateDocumentRequestToJSONTyped(value?: EstimateDocumentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentId': value['documentId'],
    };
}

